import { ContributorType } from "@gtmhub/goals/models";
import { byNumericField } from "../../../util/sorting";

export interface ICloneOkrsOrderId {
  shouldSetOrderId: boolean;
  newOrderId?: number;
}

export const calculateOrderIdWhenCloningIntoSameParent = (parentContributors: ContributorType[], originalOrderId: number): ICloneOkrsOrderId => {
  parentContributors.sort(byNumericField("orderId"));

  let newOrderId: number;
  let shouldSetOrderId = false;
  parentContributors.some((contributor, idx) => {
    if (idx === parentContributors.length - 1) {
      return true;
    }

    if (contributor.orderId === originalOrderId) {
      newOrderId = (contributor.orderId + parentContributors[idx + 1].orderId) / 2;
      shouldSetOrderId = true;
      return true;
    }

    return false;
  });

  return { shouldSetOrderId, newOrderId };
};
